export default __webpack_public_path__ + "static/media/mamografia.2395692a.png";